import $ from 'jquery'

class Navigation {
    constructor() {
        document.querySelector("#main-nav-toggle").addEventListener("click", () => {
            document.body.classList.toggle('is-navigation')
        })
    }
}

export default Navigation